import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { getRootStore } from "@/stores/RootStore";
import { observer } from "mobx-react-lite";
import { canEditDictionaries } from "@/utils/permissions";
import { canDeleteFromDictionaries } from "@/utils/permissions";
import { message, Modal, Skeleton, Card, Button, Flex } from "antd";
import styles from "@/styles/VehicleModelPage.module.less";
import { ArrowLeftOutlined, DeleteOutlined } from "@ant-design/icons";
import VehicleModelForm from "@/components/VehicleModelForm/VehicleModelForm";
export const VehicleModelPage = observer(() => {
    const navigate = useNavigate();
    const { vehicleModelId } = useParams();
    const { singleVehicleModelStore: store, authStore: { userRole }, } = getRootStore();
    const { vehicleModel, loading, vehicleManufacturerSelectStore } = store;
    const canEdit = canEditDictionaries(userRole);
    const canDelete = canDeleteFromDictionaries(userRole);
    useEffect(() => {
        store.init(vehicleModelId);
        return () => {
            store.clearVehicleModelData();
        };
    }, [vehicleModelId]);
    const handleBack = () => {
        navigate("/vehicle-models");
    };
    const handleSave = async (values) => {
        const isNewVehicleModel = !vehicleModel;
        store.saveVehicleModel(values).then((savedVehicleModel) => {
            if (savedVehicleModel) {
                if (isNewVehicleModel) {
                    message.success("Модель автомобиля успешно создана");
                    navigate(`/vehicle-models/${savedVehicleModel.id}`);
                }
                else {
                    message.success("Модель автомобиля успешно обновлена");
                }
            }
        });
    };
    const handleDeleteVehicleModel = () => {
        if (!vehicleModel)
            return;
        Modal.confirm({
            title: "Удаление модели автомобиля",
            content: "Вы уверены, что хотите удалить эту модель автомобиля?",
            okText: "Удалить",
            okType: "danger",
            cancelText: "Отмена",
            onOk: async () => {
                await store.deleteVehicleModel(vehicleModel.id);
                message.success("Модель автомобиля успешно удалена");
                handleBack();
            },
        });
    };
    if (loading) {
        return (_jsx("div", { className: styles.container, children: _jsx(Card, { children: _jsx(Skeleton, { active: true, paragraph: { rows: 8 } }) }) }));
    }
    return (_jsxs(Flex, { vertical: true, gap: "large", className: styles.container, children: [_jsx("div", { className: styles.backButtonContainer, children: _jsx(Button, { icon: _jsx(ArrowLeftOutlined, {}), onClick: handleBack, type: "text", className: styles.backButton, children: "\u041D\u0430\u0437\u0430\u0434 \u043A \u0441\u043F\u0438\u0441\u043A\u0443" }) }), _jsx(VehicleModelForm, { vehicleModel: vehicleModel, loading: loading, onSubmit: handleSave, onCancel: handleBack, disabled: !canEdit, extraButtons: canDelete &&
                    vehicleModel && (_jsx(Button, { danger: true, icon: _jsx(DeleteOutlined, {}), onClick: handleDeleteVehicleModel, children: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043C\u043E\u0434\u0435\u043B\u044C \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u044F" })), selectStores: {
                    vehicleManufacturerSelectStore,
                } })] }));
});
export default VehicleModelPage;
